import axios from 'axios';

/**
 * Many legacy screens call the LangGraph backend with bare `fetch`, the global `axios`,
 * or `new WebSocket`, using `getLangGraphBaseUrl()`. In production that URL is Node's
 * `/api/v1/langgraph-proxy`, which requires the JWT (sign-in sets no session cookie), so
 * attach it here for same-origin proxy URLs only. WebSockets carry it as the
 * subprotocol pair `['bearer', <jwt>]` because browsers cannot set socket headers.
 */
const PROXY_PATH = '/api/v1/langgraph-proxy/';

const currentToken = () => {
  try {
    return window.localStorage.getItem('tkn');
  } catch {
    return null;
  }
};

export const isLangGraphProxyUrl = (raw) => {
  if (!raw) return false;
  try {
    const url = new URL(String(raw), window.location.href);
    const sameHost = url.host === window.location.host;
    return sameHost && url.pathname.startsWith(PROXY_PATH);
  } catch {
    return false;
  }
};

let installed = false;

export function installLangGraphProxyAuth() {
  if (installed || typeof window === 'undefined') return;
  installed = true;

  const nativeFetch = window.fetch.bind(window);
  window.fetch = (input, init = {}) => {
    const url = input instanceof Request ? input.url : input;
    const token = isLangGraphProxyUrl(url) ? currentToken() : null;
    if (!token) return nativeFetch(input, init);
    const headers = new Headers(init.headers || (input instanceof Request ? input.headers : undefined));
    if (!headers.has('Authorization')) headers.set('Authorization', `Bearer ${token}`);
    return nativeFetch(input, { ...init, headers });
  };

  axios.interceptors.request.use((config) => {
    const token = isLangGraphProxyUrl(axios.getUri(config)) ? currentToken() : null;
    if (token && !config.headers?.Authorization) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  });

  const NativeWebSocket = window.WebSocket;
  if (!NativeWebSocket) return;
  class LangGraphProxyWebSocket extends NativeWebSocket {
    constructor(url, protocols) {
      const token = isLangGraphProxyUrl(String(url).replace(/^ws/, 'http')) ? currentToken() : null;
      if (!token) {
        super(url, protocols);
        return;
      }
      const offered = protocols == null ? [] : [].concat(protocols);
      super(url, ['bearer', token, ...offered]);
    }
  }
  window.WebSocket = LangGraphProxyWebSocket;
}
